<div [formGroup]="form" appClickOutsideModal (clickOutside)="closeModal()">
  <div class="modal-header content-header">
    <button
      type="button"
      class="close close-modal"
      aria-label="Close"
      (click)="closeModal()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <ng-container *ngIf="result === editResult.Default">
    <ng-container *ngTemplateOutlet="default"></ng-container>
  </ng-container>
  <ng-container *ngIf="result === editResult.Success">
    <ng-container *ngTemplateOutlet="success"></ng-container>
  </ng-container>
  <ng-container *ngIf="result === editResult.Error">
    <ng-container *ngTemplateOutlet="error"></ng-container>
  </ng-container>

  <ng-template #default>
    <div class="edit-card">
      <div class="edit-card-title">ACTUALIZAR DATOS DE TARJETA</div>
      <div class="edit-card-subtitle">
        {{ this.userCard.cardBrandName }} que termina en
        {{ this.userCard.last4 }}
      </div>
      <div class="edit-card-form">
        <div class="edit-card-form-add-number">
          <label for="number" class="form-label">Número de tarjeta:</label>
          <div
            class="input-icon-wrapper"
            [class.invalid]="
              form.get('number')?.invalid && form.get('number')?.touched
            "
          >
            <input
              id="number"
              type="text"
              formControlName="number"
              placeholder="xxxx-xxxx-xxxx-xxxx"
              [class.invalid]="
                form.get('number')?.invalid && form.get('number')?.touched
              "
            />
            <div class="icon-box">
              <span>
                <i class="iconlace iconlace-card"></i>
              </span>
            </div>
          </div>
          <div
            *ngIf="
              form.get('number')?.hasError('required') &&
              form.get('number')?.touched
            "
            class="error-message"
          >
            <small>El número de la tarjeta es requerido.</small>
          </div>
          <div
            *ngIf="
              form.get('number')?.errors?.invalidEnding &&
              form.get('number')?.touched
            "
            class="error-message"
          >
            <small>El número de la tarjeta es invalido.</small>
          </div>
        </div>
        <div class="edit-card-form-add-exp-date">
          <label for="expDate" class="form-label">Fecha de vencimiento</label>
          <div
            class="input-icon-wrapper"
            [class.invalid]="
              (form.get('expDate')?.hasError('required') ||
                form.get('expDate')?.errors) &&
              form.get('expDate')?.touched
            "
          >
            <input
              id="expDate"
              type="text"
              formControlName="expDate"
              placeholder="MM/AA"
              [class.invalid]="
                (form.get('expDate')?.hasError('required') ||
                  form.get('expDate')?.errors) &&
                form.get('expDate')?.touched
              "
            />
            <div class="icon-box">
              <i class="iconlace iconlace-calendar"></i>
            </div>
          </div>
          <div
            *ngIf="
              (form.get('expDate')?.hasError('required') ||
                form.get('expDate')?.errors?.incomplete) &&
              form.get('expDate')?.touched
            "
            class="error-message"
          >
            <small> La fecha de la tarjeta es requerido. </small>
          </div>
          <div
            *ngIf="form.get('expDate')?.errors && form.get('expDate')?.touched"
            class="error-message"
          >
            <!--<small *ngIf="form.get('expDate')?.errors?.invalidFormat">-->
            <!--  Formato inválido. Usa MM/AA.-->
            <!--</small>-->
            <small *ngIf="form.get('expDate')?.errors?.invalidDate">
              La fecha de vencimiento es invalida.
            </small>
            <small *ngIf="form.get('expDate')?.errors?.yearOutOfRange">
              La fecha de vencimiento es invalida.
            </small>
            <small *ngIf="form.get('expDate')?.errors?.expired">
              La fecha de vencimiento es invalida.
            </small>
          </div>
        </div>
        <div class="edit-card-form-add-cvv">
          <label for="cvv" class="form-label">Código de seguridad</label>
          <div
            class="input-icon-wrapper"
            [class.invalid]="
              form.get('cvv')?.invalid && form.get('cvv')?.touched
            "
          >
            <input
              id="cvv"
              type="text"
              formControlName="cvv"
              placeholder="Ingresa el CVV (dígitos al dorso)"
              [class.invalid]="
                form.get('cvv')?.invalid && form.get('cvv')?.touched
              "
            />
            <div class="icon-box">
              <i class="iconlace iconlace-card"></i>
            </div>
          </div>
          <div
            *ngIf="
              form.get('cvv')?.hasError('required') && form.get('cvv')?.touched
            "
            class="error-message"
          >
            <small>El CVV de la tarjeta es requerido.</small>
          </div>
        </div>
      </div>
      <div class="edit-card-button-container" [class.disabled]="form.invalid">
        <button class="card-button" (click)="updateCreditCard()">
          ACTUALIZAR TARJETA
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #success>
    <div class="success-edit-card">
      <div class="success-edit-card-icon-box">
        <span>
          <i class="iconlace iconlace-succes"></i>
        </span>
      </div>

      <div class="success-edit-card-title">¡Listo!</div>
      <div class="success-edit-card-subtitle">
        La tarjeta terminada en {{ this.userCard.last4 }} <br />
        ha sido actualizada exitosamente
      </div>

      <div class="edit-card-button-container">
        <button class="card-button" (click)="closeModal()">ACEPTAR</button>
      </div>
    </div>
  </ng-template>

  <ng-template #error>
    <div class="error-edit-card">
      <div class="error-edit-card-icon-box">
        <span>
          <i class="iconlace iconlace-alert"></i>
        </span>
      </div>

      <div class="error-edit-card-title">¡Hubo un error al actualizar!</div>
      <div class="error-edit-card-subtitle" style="margin-bottom: 10px">
        El código de activación que ingresaste no está asociado a ningún plan.
      </div>
      <div class="error-edit-card-subtitle">
        Verifícalo e inténtalo nuevamente.
      </div>

      <div class="edit-card-button-container">
        <button class="card-button" (click)="closeModal()">ACEPTAR</button>
      </div>
    </div>
  </ng-template>
</div>
